import React, {useContext, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {Alert, Stack, TextField} from "@mui/material";


function AddGuardian(props) {
    const title = 'Dodaj Opiekuna Prawnego';
    const description = '';

    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [city, setCity] = useState('');
    const [street, setStreet] = useState('');
    const [work, setWork] = useState('');

    function _send() {
        const formData = {
            name: name,
            surname: surname,
            email: email,
            phone: phone,
            postal_code: postalCode,
            city: city,
            street: street,
            work: work
        };
        fetch(`/api/children/${props.isOpen}/guardian`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }

    return (<StyledModal isOpen={props.isOpen} title={title} description={description} send={_send} dismiss={props.dismiss}>
        <Stack direction={'row'} spacing={2}>
            <Stack spacing={2} sx={{flexGrow: '1'}}>
                <TextField
                    onChange={(e) => setName(e.target.value)}
                    label='Imię'
                    value={name}
                    variant="outlined"
                    fullWidth
                />
        <TextField
            onChange={(e) => setSurname(e.target.value)}
            label='Nazwisko'
            value={surname}
            variant="outlined"
            fullWidth
        />
        <TextField
            onChange={(e) => setEmail(e.target.value)}
            label='Email'
            value={email}
            variant="outlined"
            required
            fullWidth
        />

            </Stack>
            <Stack spacing={2}>

                <TextField
                    onChange={(e) => setStreet(e.target.value)}
                    label='Adres'
                    value={street}
                    variant="outlined"
                    fullWidth
                />
                <Stack direction={'row'} spacing={2}>
                    <TextField
                        onChange={(e) => setPostalCode(e.target.value)}
                        label='Kod Pocztowy'
                        value={postalCode}
                        variant="outlined"

                    />
                    <TextField
                        onChange={(e) => setCity(e.target.value)}
                        label='Miasto'
                        value={city}
                        variant="outlined"
                        fullWidth
                    />
                </Stack>
                <TextField
                    onChange={(e) => setPhone(e.target.value)}
                    label='Telefon kontaktowy'
                    value={phone}
                    variant="outlined"
                    fullWidth
                />
            </Stack>
        </Stack>
        <TextField
            onChange={(e) => setWork(e.target.value)}
            label='Miejsce wykonywania pracy'
            value={work}
            variant="outlined"
            fullWidth
            multiline
            rows={3}
        />
        </StyledModal>);
}
export default AddGuardian;